var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7672 8.2393C33.571 8.03654 33.2866 7.95489 33.0167 8.02429L27.954 8.72782C27.5313 8.83668 27.2733 9.2803 27.3786 9.71847C27.4853 10.1553 27.9158 10.422 28.3371 10.3131L30.6888 10.1482L26.043 14.9226H14.5766C14.4028 14.9226 14.233 14.9824 14.0947 15.0927L6.30827 21.5372C5.96333 21.812 5.8975 22.325 6.16345 22.6816C6.3188 22.8911 6.55315 23 6.79013 23C6.95865 23 7.12848 22.9456 7.27199 22.8299L14.8452 16.5542H26.388C26.6078 16.5542 26.8172 16.4603 26.9673 16.2929L31.9301 11.4374L32.0515 13.6183C31.9461 14.0565 32.2029 14.4988 32.6268 14.609C32.6913 14.6253 32.7558 14.6335 32.819 14.6335C33.1732 14.6335 33.4944 14.3858 33.5852 14.0157L33.9765 9.01495C34.0436 8.73598 33.9647 8.44205 33.7685 8.2393H33.7672Z",
    fill: "#00D8AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2068 20.8966C27.2068 19.8491 28.0559 19 29.1033 19C30.1508 19 30.9999 19.8491 30.9999 20.8966V34.1724H27.2068V20.8966Z",
    fill: "#5EBCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1379 23.1725C21.1379 22.1251 21.9871 21.2759 23.0345 21.2759C24.0819 21.2759 24.931 22.1251 24.931 23.1725V34.1725H21.1379V23.1725Z",
    fill: "#5EBCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0688 25.4478C15.0688 24.4004 15.918 23.5513 16.9654 23.5513C18.0128 23.5513 18.8619 24.4004 18.8619 25.4478V34.172H15.0688V25.4478Z",
    fill: "#5EBCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.7238C9 26.6764 9.84911 25.8273 10.8966 25.8273C11.944 25.8273 12.7931 26.6764 12.7931 27.7238V34.1721H9V27.7238Z",
    fill: "#5EBCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2273 35.4613H3.77273C3.34644 35.4613 3 35.0146 3 34.4613C3 33.9096 3.34644 33.4613 3.77273 33.4613H36.2273C36.6536 33.4613 37 33.9096 37 34.4613C37 35.013 36.6536 35.4613 36.2273 35.4613Z",
    fill: "#8FCFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock40);
export default __webpack_public_path__ + "static/media/clock_40.af176aaa3c8f1392baf659aedc587dc8.svg";
export { ForwardRef as ReactComponent };